const state = {
    opportunities: [],
    opportunityId: [],
    newOpportunity: {},
    pipelines: [],
    loading: false
};

export default state;